import * as React from 'react';
import ReactDataSheet from 'react-datasheet';

import Select from 'react-select';

import { IGridElement, SelectOption } from '../types';

const TAB_KEY = 9;
const ENTER_KEY = 13;

interface ISelectEditorState {
  e?: React.KeyboardEvent<HTMLElement>;
}
interface ISelectEditorProps
  extends ReactDataSheet.DataEditorProps<IGridElement> {
  portalElement: HTMLDivElement | null;
}

const simpleStyles = {
  container: (provided: any) => provided,
  control: (provided: any) => ({
    ...provided,
    background: '#fff',
    minHeight: 32,
    borderRadius: 0,
  }),
  input: (provided: any) => ({
    ...provided,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: state.isFocused ? '#00a1e4' : provided.color,
    padding: '6px',
  }),
  menu: (provided: any) => ({
    ...provided,
    overflow: 'hidden',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    background: '#fff',
  }),
  option: (provided: any, state: any) => {
    return {
      ...provided,
      backgroundColor: state.data.value.highlight
        ? '#f8bbab'
        : provided.backgroundColor,
      color: state.data.value.highlight ? '#ed5d35' : provided.color,
    };
  },
};

class SelectEditor extends React.Component<
  ISelectEditorProps,
  ISelectEditorState
> {
  state: ISelectEditorState = {
    e: undefined,
  };

  handleChange = (opt: SelectOption) => {
    const { onCommit, onRevert } = this.props;
    if (!opt) {
      return onRevert();
    }
    const { e } = this.state;
    onCommit(String(opt.value.id), e);
    console.log('COMMITTED', opt.value);
  };

  handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    // record last key pressed so we can handle enter
    if (e.which === ENTER_KEY || e.which === TAB_KEY) {
      e.persist();
      this.setState({ e });
    } else {
      this.setState({ e: undefined });
    }
  };

  render() {
    const options = this.props.cell.options;
    const value =
      options &&
      options.find((o) => String(o.value.id) === this.props.cell.value);
    return (
      <Select
        styles={simpleStyles}
        autoFocus={true}
        menuIsOpen={true}
        closeOnSelect={true}
        value={value}
        onChange={this.handleChange}
        onInputKeyDown={this.handleKeyDown}
        options={options}
        menuPortalTarget={this.props.portalElement}
      />
    );
  }
}

export default SelectEditor;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/SelectEditor.tsx